/* eslint-disable */
const $ = jQuery.noConflict();

'use strict';
const SingleProduct = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.addToCart();
		$('.js-single-add-to-cart-variation').on('click', function() {
			$('.js-single_add_to_cart_button-var').trigger('click');
		});
		this.attributesByVariationCombination();
		this.reinitializeSelect2AfterVariationCombinationReset();
	},

	reinitializeSelect2AfterVariationCombinationReset: function() {
		// Listen to the reset_data event on the single product page
		$('form.variations_form').on('reset_data', function() {
			// Find all dropdowns with Select2 in the variations form
			$(this)
				.find('.variations select')
				.each(function() {
					// Destroy existing Select2 instance if already initialized
					if ($(this).hasClass('select2-hidden-accessible')) {
						$(this).select2('destroy');
					}
					// Reinitialize Select2 with the required options
					$(this).select2({
						minimumResultsForSearch: -1, // Disable the search box
						width: 'style', // Use the style width of the select element
						dropdownCssClass: 'single-product-select__dropdown-size-color', // Custom dropdown class
						placeholder: 'Odaberi opciju', // Placeholder text
						allowClear: true // Allow clearing the selection
					});
				});
		});
	},

	attributesByVariationCombination: function() {
		// Automatically select the first variation on page load if it's a variable product
		const $variationsForm = $('.variations_form');
		// if ($variationsForm.length && variationAttributesData && Object.keys(variationAttributesData).length > 0) {
		// 	// Pre-select the first variation
		// 	const firstVariation = Object.keys(variationAttributesData)[0]; // Get the first variation ID
		// 	const variation = variationAttributesData[firstVariation];
		//
		// 	if (variation) {
		// 		$variationsForm.find('select').each(function() {
		// 			const $select = $(this);
		// 			const attributeName = $select.attr('name');
		// 			const firstOption = variation[attributeName.replace('attribute_', '')];
		// 			if (firstOption) {
		// 				$select.val(firstOption[0]).trigger('change');
		// 			}
		// 		});
		//
		// 		$variationsForm.trigger('woocommerce_variation_has_changed');
		// 	}
		// }

		// Show attributes dynamically when a variation is selected
		$variationsForm.on('show_variation', function(event, variation) {
			if (!variation.variation_id) {
				console.warn('Id varijacije nije dostupan.');
				return;
			}

			const attributesData = variationAttributesData[variation.variation_id];
			const attributesContainer = $(".product-attributes");

			if (!attributesData) {
				console.warn('Attributi za varijaciju ne postoje.');
				return;
			}

			let html = '';

			// Maintain consistent order using attributeOrder
			attributeOrder.forEach((taxonomy) => {
				const label = taxonomy.replace('pa_', '').replace(/_/g, ' ').replace(/-/g, ' ').toUpperCase();
				const terms =
					attributesData[taxonomy] || allProductAttributes[taxonomy] || ['N/A'];
				html += `<div class="product-attributes-row">
                        <div class="product-attributes-label">${label}</div>
                        <div class="product-attributes-value">${terms.join(', ')}</div>
                     </div>`;
			});

			attributesContainer.html(html);

			// Update SKU in the specified HTML element
			const skuContainer = $(".single-product__upper-right-title-info-text");
			if (skuContainer.length && variation.sku) {
				skuContainer.text('SKU: ' + variation.sku);
			} else if (skuContainer.length) {
				skuContainer.text('Sku nije dostupan');
			}
		});

		// Reset attributes and show parent SKU when no variation is selected
		$variationsForm.on('hide_variation', function() {
			const attributesContainer = $(".product-attributes");
			const skuContainer = $(".single-product__upper-right-title-info-text");
			const parentSku = $(".js-parent-sku").data("parent-sku"); // Assumes parent SKU is stored here

			let html = '';

			// Maintain consistent order using attributeOrder
			attributeOrder.forEach((taxonomy) => {
				const label = taxonomy.replace('pa_', '').replace(/_/g, ' ').replace(/-/g, ' ').toUpperCase();
				const terms = allProductAttributes[taxonomy] || ['N/A'];
				html += `<div class="product-attributes-row">
                        <div class="product-attributes-label">${label}</div>
                        <div class="product-attributes-value">${terms.join(', ')}</div>
                     </div>`;
			});

			attributesContainer.html(html);

			// Update SKU with the parent SKU
			if (skuContainer.length && parentSku) {
				skuContainer.text('SKU: ' + parentSku);
			} else if (skuContainer.length) {
				skuContainer.text('Sku nije dostupan');
			}
		});
	},

	addToCart: function() {
		const button = document.querySelector('.js-add-to-cart-single-product');
		if (!button) {
			return false;
		}
		console.log(button);

		const handleInput = () => {
			const qty = document.querySelector('.js-fake-qty input');
			if (!qty) {
				return false;
			}
			const qtyHidden = document.querySelector('form.cart .quantity input.input-text.qty');
			if (!qtyHidden) {
				return false;
			}
			qtyHidden.value = qty.value;
			const buttonHidden = document.querySelector('button.single_add_to_cart_button');
			if (buttonHidden) {
				buttonHidden.click();
			}
		};

		button.addEventListener('click', handleInput);
	}
};

export default SingleProduct;
